import { checkURL } from '~/src/dash/components/vast-editor';

export function changeFavicon(logoURL: string) {
  let link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");
  if (!link) {
    link = document.createElement('link');
  }
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = logoURL;
  document.getElementsByTagName('head')[0].appendChild(link);
}

// publica and reseller domains
export const isPBSDomain = (url: string): boolean => {
  const localDomains = [
    'getpublica.com',
    'pbs.getpublica.com',
    'pbs2.getpublica.com',
    'prebid-log.getpublica.com',
    'pbs-vmap.getpublica.com',
    'pblog-vmap.getpublica.com',
    'stg-publica-ctv.com',

    'evrideo-ads.tv',
    'pbs.evrideo-ads.tv',
    'pblog.evrideo-ads.tv',

    'philo.com',
    'pbs.ads.philo.com',
    'pblog.ads.philo.com',

    'pacific.orka.biz',
    'mas.pacific.orka.biz',
    'pblog.pacific.orka.biz',

    'ads.ottera.tv',
    'obs.ads.ottera.tv',
  ];

  const urlDomain = extractURLDomain(url);

  return localDomains.some((domain) => urlDomain.includes(domain));
};

export const extractURLDomain = (url: string): string => {
  if (!checkURL.test(url)) {
    return '';
  }

  let startIdx = url.indexOf('//');
  if (startIdx === -1) {
    return '';
  }
  startIdx += 2;

  let endIdx = startIdx;
  for (; endIdx < url.length; endIdx += 1) {
    if (url[endIdx] === '/') {
      break;
    }
  }

  return url.slice(startIdx, endIdx);
};

export const findDCMParams = (url: string): URLSearchParams => {
  const params: URLSearchParams = new URLSearchParams();
  const splitURL = url.split(';');
  const paramsList = splitURL.slice(1);
  for (const paramPair of paramsList) {
    const splitParams = paramPair.split('=');
    if (splitParams.length === 2) {
      params.append(splitParams[0], splitParams[1]);
    }
  }

  return params;
};
